export const FB_PIXEL_ID = '1259271841764916'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export function initFBPixel() {
  if (typeof window === 'undefined') return
  if (window.fbq) return

  // Step 1: Set up fbq function and queue manually
  const fbq: any = function (...args: any[]) {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, args)
    } else {
      fbq.queue.push(args)
    }
  }
  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = [] as any[]

  window.fbq = fbq
  window._fbq = fbq

  // Step 2: Load fbevents.js as external script
  const scriptEl = document.createElement('script')
  scriptEl.async = true
  scriptEl.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(scriptEl, firstScript)
  } else {
    document.head.appendChild(scriptEl)
  }

  // Step 3: Init pixel only — PageView is handled by PageViewTracker
  window.fbq('init', FB_PIXEL_ID)
}

export function trackPageView() {
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackLead(data?: Record<string, unknown>) {
  if (window.fbq) {
    window.fbq('track', 'Lead', data)
  }
}

export function trackCompleteRegistration(data?: Record<string, unknown>) {
  if (window.fbq) {
    window.fbq('track', 'CompleteRegistration', data)
  }
}

export function trackCustomEvent(
  eventName: string,
  data?: Record<string, unknown>,
) {
  if (window.fbq) {
    window.fbq('trackCustom', eventName, data)
  }
}
